<template>
  <div class="bids-list tab-table p-2">
    <BidsTable :exclude-search-fields="excludeSearchFields"
               :exclude-columns="['stock_no', 'sale_no']"/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import BidsTable from "@/modules/bids/BidsTable";

  const {mapState} = createNamespacedHelpers('sales');
  const {mapActions: bidsMapActions} = createNamespacedHelpers('bids');

  export default {
    name: "BidsList",
    components: {BidsTable},
    data() {
      return {
        excludeSearchFields: ['stock_no'],
      }
    },
    computed: {
      ...mapState({
        sale: state => state.view.currentSale
      })
    },
    methods: {
      ...bidsMapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'sale',
        extraFilters: {auction_uuid: this.sale.uuid},
        sale: this.sale
      });
    }
  }
</script>

<style lang="scss" scoped>
</style>
